import { socketImportProcess } from '@nxsys/services/sockets';
import { useCallback, useEffect } from 'react';

export type SocketEvent = {
  type: string;
  success?: boolean;
  message?: string;
  data?: any;
  progress?: number;
  error?: {
    message: string;
  };
};

export type UseSocketOptions = {
  eventName: string;
  onSuccess?: (data: any) => void;
  onError?: (error: string) => void;
  onSettled?: () => void;
};

export const useImportSocket = (options: UseSocketOptions): void => {
  const { eventName, onSuccess, onError, onSettled } = options;

  const handleSocketEvent = useCallback(
    (eventData: SocketEvent) => {
      if (eventData?.success) {
        onSuccess?.(eventData);
      } else {
        onError?.(eventData?.error?.message || '');
      }
      onSettled?.();
    },
    [onSuccess, onError],
  );

  useEffect(() => {
    // Set up socket event listeners
    socketImportProcess.on(eventName, handleSocketEvent);

    // Cleanup function
    return () => {
      socketImportProcess.off(eventName, handleSocketEvent);
    };
  }, [handleSocketEvent]);
};

export default useImportSocket;
